
import React from 'react';
import { Input, Form } from 'antd';


const { TextArea } = Input;

const Instructions=(props)=>{
    return(
        <div>
          <Form.Item
            name="note"
          >
          <TextArea rows={4} placeholder="Notes" onChange={(e)=>{
            let val = (e.target.value);
              if(props.form){
                props.form.setFieldsValue({
                  note: val
                })
              }
          }}/>
          </Form.Item>
        </div>
    )
}

export default Instructions